import {formatDate} from "utils/lib";
import {CUSTOMER_APP_ID, DATE_FORMAT} from "../config/constants";
import {
  IAddUpdateAgentManagementPageState,
  IAgentManagementUsersNormalized,
  IAllAgentRolesResponse,
  ICreateAgentOnlyReq,
  ICreateUpdateAgentManagementUserNormalizedReq,
  IZonesResponseObject,
} from "../interfaces/Index";

export const normalizeCreateAgentOnlyPayload = (
  req: IAddUpdateAgentManagementPageState
): ICreateAgentOnlyReq => {
  return {
    userId: req.userId,
    title: (req.title as any).id,
    teamId: (req.team as any).id,
    customerChannel: req.customerChannel?.id || "",
    agentName: req.agentName,
    phoneNumber: req.phoneNumber,
    status: req.status ? "ACTIVE" : "INACTIVE",
    zones: normalizeCreateUpdateZoneReq(req.zones),
    brands: normalizeCreateUpdateBrandsReq(req.brands),
  };
};

export const normalizeAgentManagementUserCreatePayload = (
  req: IAddUpdateAgentManagementPageState
): ICreateUpdateAgentManagementUserNormalizedReq => {
  return {
    userId: req.userId,
    title: (req.title as any).id,
    teamId: (req.team as any).id,
    customerChannel: (req.customerChannel as any).id,
    agentName: req.agentName,
    phoneNumber: req.phoneNumber,
    status: req.status ? "ACTIVE" : "INACTIVE",
    zones: normalizeCreateUpdateZoneReq(req.zones),
    password: req.password,
    confirmPassword: req.password,
    nationalId: req.nationalId,
    agentId: req.agentId,
    email: req.email,
    brands: normalizeCreateUpdateBrandsReq(req.brands),
  };
};

export const normalizeAgentManagementUserUpdatePayload = (
  req: IAddUpdateAgentManagementPageState
): ICreateUpdateAgentManagementUserNormalizedReq => {
  return {
    id: req.id,
    agentId: req.agentId,
    nationalId: req.nationalId,
    userId: req.userId,
    email: req.email,
    status: req.status ? "ACTIVE" : "INACTIVE",
    agentName: req.agentName,
    phoneNumber: req.phoneNumber,
    title: (req.title as any).id,
    teamId: (req.team as any).id,
    customerChannel: req.customerChannel?.id || "",
    zones: normalizeCreateUpdateZoneReq(req.zones),
    brands: normalizeCreateUpdateBrandsReq(req.brands)
  };
};

const normalizeCreateUpdateZoneReq = (
  zones: Array<any>
) => {
  return zones.map((zone) => {
    return {
      zoneId: zone.id
    }
  });
};

const normalizeCreateUpdateBrandsReq = (
    brands: Array<any>
) => {
  return brands.map((brand) => {
    return {
      brandId: brand.id
    }
  });
};

export const normalizeFetchAgentManagementUserResponse = (
  res: Array<IAgentManagementUsersNormalized>,
  pagination: any,
  isPaginatedRes: boolean
) => {
  let payload: any = {
    pagination: res.length === 50 ? pagination : false,
    isPaginatedRes,
  };
  const agentManagementUserPayload: Array<IAgentManagementUsersNormalized> = res.map(
    (agentManagementUser) => {
      return {
        userId: agentManagementUser.userId,
        agentId: agentManagementUser.agentId,
        name: agentManagementUser.name,
        phoneNumber: agentManagementUser.phoneNumber,
        countryCode: agentManagementUser.countryCode,
        cnicNumber: agentManagementUser.cnicNumber,
        status: agentManagementUser.status,
        teamId: agentManagementUser.teamId,
        customerChannel: agentManagementUser.customerChannel,
        titleId: agentManagementUser.title,
        title: agentManagementUser.title,
        zones: agentManagementUser.zones.slice(),
        brands: agentManagementUser.brands.slice(),
        agentTeamName: agentManagementUser.agentTeamName,
        agentTitleName: agentManagementUser.agentTitleName,
        email: agentManagementUser.email,
        createdByUser: agentManagementUser.createdByUser,
        createdAt: formatDate(agentManagementUser.createdAt, DATE_FORMAT.DAY_MONTH_TIME12),
        updatedByUser: agentManagementUser.updatedByUser,
        updatedAt: formatDate(agentManagementUser.updatedAt, DATE_FORMAT.DAY_MONTH_TIME12),
      };
    }
  );
  payload.agentManagementUserData = agentManagementUserPayload;
  return payload;
};

export const normalizedZones = (res: IAllAgentRolesResponse[]) => {
  return res
    .filter((item) => item.id !== CUSTOMER_APP_ID)
    .map((zone: IZonesResponseObject) => {
      return {
        id: zone.id,
        name: zone.name,
      };
    });
};

export const normalizeAgentTitle = (title: any) => {
  return title.map((type: any) => {
    return {
      id: type.id,
      value: type.id,
      label: type.value,
    };
  });
};

export const normalizeAgentTeam = (team: any) => {
  return team.map((type: any) => {
    return {
      id: type.id,
      value: type.id,
      label: type.value,
    };
  });
};

export const normalizeBrands = (brands: any) => {
  return brands.map((type: any) => {
    return {
      id: type.id,
      value: type.id,
      label: type.value,
    };
  });
};